var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.464,
    height: 161.464,
    viewBox: "0 0 161.464 161.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M80.732.563a80.732,80.732,0,1,0,80.732,80.732A80.718,80.718,0,0,0,80.732.563Zm0,31.251A28.647,28.647,0,1,1,52.085,60.461,28.647,28.647,0,0,1,80.732,31.814Zm0,111.983a62.381,62.381,0,0,1-47.691-22.2,36.3,36.3,0,0,1,32.065-19.467,7.966,7.966,0,0,1,2.311.358,43.1,43.1,0,0,0,13.314,2.246,42.938,42.938,0,0,0,13.314-2.246,7.965,7.965,0,0,1,2.311-.358A36.3,36.3,0,0,1,128.423,121.6,62.381,62.381,0,0,1,80.732,143.8Z",
    transform: "translate(0 -0.563)",
    fill: "#e1e1e1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImg);
export default __webpack_public_path__ + "static/media/default-user-img.49b1be63c5a0b47b759f1844289bfb50.svg";
export { ForwardRef as ReactComponent };